import React, { useState, useRef } from "react"; 
import "./ContactSec4.css";
import { Button, Stack } from "react-bootstrap";
import { submitB2BEnquiry } from "../../../API/contact";
import { useLocation } from "react-router-dom";
import { SuccessModal } from "../../../Common/SuccessModal";
const TRAVEL_TYPES = [
  "Leisure",
  "Corporate",
  "MICE (Meetings, Incentives, Conferences & Events)",
  "Honeymoon",
  "Adventure",
  "Group Tour",
  "Religious / Pilgrimage",
  "Educational / School Tour",
  "Other",
];

const PAX_RANGES = [
  "1 – 5",
  "6 – 10",
  "11 – 25",
  "26 – 50",
  "51 – 100",
  "101 – 200",
  "200+",
];

const INITIAL_STATE = {
  name: "",
  companyName: "",
  email: "",
  contactNumber: "",
  destinations: "",
  travelType: "",
  noOfPersons: "",
  travelMonth: "",
  message: "",
};

export const ContactSec4 = ({ bg }) => {
  const [inputValue, setInputValue] = useState(INITIAL_STATE);
  const [errors, setErrors] = useState({});
  const dateRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value }));
    // Clear error on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!inputValue.name.trim()) newErrors.name = "Full name is required.";

    if (!inputValue.companyName.trim())
      newErrors.companyName = "Company name is required.";

    if (!inputValue.email.trim()) {
      newErrors.email = "Email address is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!inputValue.contactNumber.trim()) {
      newErrors.contactNumber = "Contact number is required.";
    } else if (!/^[+\d\s\-()\u0020]{7,15}$/.test(inputValue.contactNumber)) {
      newErrors.contactNumber = "Please enter a valid contact number.";
    }

    if (!inputValue.destinations.trim())
      newErrors.destinations = "Please enter at least one destination.";

    if (!inputValue.travelType)
      newErrors.travelType = "Please select a travel type.";

    if (!inputValue.noOfPersons)
      newErrors.noOfPersons = "Please select estimated number of pax.";

    if (!inputValue.travelMonth.trim())
      newErrors.travelMonth = "Tentative travel month is required.";

    if (!inputValue.message.trim())
      newErrors.message = "Please enter your requirements or message.";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        fullName: inputValue.name,
        companyName: inputValue.companyName,
        email: inputValue.email,
        phoneNo: inputValue.contactNumber,
        destinations: inputValue.destinations,
        travelType: inputValue.travelType,
        noOfPax: parseInt(inputValue.noOfPersons) || 0,
        travelMonth: inputValue.travelMonth,
        message: inputValue.message,
        // ✅ ADD THIS
        slug: window.location.pathname,
      };

      const res = await submitB2BEnquiry(payload);

      setShowSuccess(true)

      setInputValue(INITIAL_STATE);
      setErrors({});
    } catch (err) {
      alert(err.message || "Submission failed ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contactsec4 standard-padding" id="request-form-id">
      <Stack
        className="contactsec4-container"
        style={{ backgroundColor: bg || "#FFFFFF" }}
      >
        <h1 className="heading mb-2" style={{ textAlign: "center" }}>
          Request Form
        </h1>
        <p className="text mb-4" style={{ textAlign: "center" }}>
          Share your travel requirements, and our team will get back with availability and pricing.
        </p>

        <form
          onSubmit={handleSubmit}
          className="contactsec4-container-form"
          noValidate
        >
          <div className="contactsec4-section other-details">
            <Stack
              direction="horizontal"
              className="contactsec4-form-container"
            >
              {/* Full Name */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">
                  Your Full Name *
                </label>
                <input
                  type="text"
                  className={`contactsec4-form-control ${errors.name ? "is-invalid" : ""}`}
                  name="name"
                  value={inputValue.name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                />
                {errors.name && (
                  <span className="contactsec4-error">{errors.name}</span>
                )}
              </div>

              {/* Company Name */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">Company Name *</label>
                <input
                  type="text"
                  className={`contactsec4-form-control ${errors.companyName ? "is-invalid" : ""}`}
                  name="companyName"
                  value={inputValue.companyName}
                  onChange={handleChange}
                  placeholder="Enter your company name"
                />
                {errors.companyName && (
                  <span className="contactsec4-error">
                    {errors.companyName}
                  </span>
                )}
              </div>

              {/* Email */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">
                  Email Address *
                </label>
                <input
                  type="email"
                  className={`contactsec4-form-control ${errors.email ? "is-invalid" : ""}`}
                  name="email"
                  value={inputValue.email}
                  onChange={handleChange}
                  placeholder="Enter your official email address"
                />
                {errors.email && (
                  <span className="contactsec4-error">{errors.email}</span>
                )}
              </div>

              {/* Contact Number */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">
                  Contact Number *
                </label>
                <input
                  type="tel"
                  className={`contactsec4-form-control ${errors.contactNumber ? "is-invalid" : ""}`}
                  name="contactNumber"
                  value={inputValue.contactNumber}
                  onChange={handleChange}
                  placeholder="Enter your contact number"
                />
                {errors.contactNumber && (
                  <span className="contactsec4-error">
                    {errors.contactNumber}
                  </span>
                )}
              </div>

              {/* Destinations */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">
                  Destination(s) *
                </label>
                <input
                  type="text"
                  className={`contactsec4-form-control ${errors.destinations ? "is-invalid" : ""}`}
                  name="destinations"
                  value={inputValue.destinations}
                  onChange={handleChange}
                  placeholder="e.g. Dubai, Kenya, South Africa"
                />
                {errors.destinations && (
                  <span className="contactsec4-error">
                    {errors.destinations}
                  </span>
                )}
              </div>

              {/* Travel Type — Dropdown */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">Travel Type *</label>
                <select
                  className={`contactsec4-form-control ${errors.travelType ? "is-invalid" : ""}`}
                  name="travelType"
                  value={inputValue.travelType}
                  onChange={handleChange}
                >
                  <option value="">Select travel type</option>
                  {TRAVEL_TYPES.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                <img src="/assets/dropdown.png" alt="" className="custom-icon" />
                {errors.travelType && (
                  <span className="contactsec4-error">
                    {errors.travelType}
                  </span>
                )}
              </div>

              {/* Estimated Number of Pax — Dropdown */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">
                  Estimated Number of Pax *
                </label>
                <select
                  className={`contactsec4-form-control ${errors.noOfPersons ? "is-invalid" : ""}`}
                  name="noOfPersons"
                  value={inputValue.noOfPersons}
                  onChange={handleChange}
                >
                  <option value="">Approximate number of travelers</option>
                  {PAX_RANGES.map((range) => (
                    <option key={range} value={range}>
                      {range}
                    </option>
                  ))}
                </select>
                <img src="/assets/dropdown.png" alt="" className="custom-icon" />
                {errors.noOfPersons && (
                  <span className="contactsec4-error">
                    {errors.noOfPersons}
                  </span>
                )}
              </div>

              {/* Tentative Travel Month */}
              <div className="contactsec4-form-group">
                <label className="contactsec4-form-label">
                  Tentative Travel Month *
                </label>
                <input
                  ref={dateRef}
                  type="date"
                  min={new Date().toISOString().split("T")[0]}
                  className={`contactsec4-form-control ${errors.travelMonth ? "is-invalid" : ""}`}
                  name="travelMonth"
                  value={inputValue.travelMonth}
                  onChange={handleChange}
                  placeholder="e.g. June 2026"
                />
                <img
                  src="/assets/calendar.png" alt=""
                  className="custom-icon1"
                  onClick={() =>
                    dateRef.current?.showPicker?.() || dateRef.current?.focus()
                  }
                />
                {errors.travelMonth && (
                  <span className="contactsec4-error">
                    {errors.travelMonth}
                  </span>
                )}
              </div>
            </Stack>
          </div>

          {/* Message */}
          <div className="contactsec4-form-group">
            <label className="contactsec4-form-label">
              Special Requirements / Message *
            </label>
            <textarea
              className={`contactsec4-form-control2 ${errors.message ? "is-invalid" : ""}`}
              name="message"
              value={inputValue.message}
              onChange={handleChange}
              placeholder="Hotels, budget range, activities, visa assistance, or any specific requirements"
            />
            {errors.message && (
              <span className="contactsec4-error">{errors.message}</span>
            )}
          </div>

          <div className="contactsec4-submit-container">
            <Button type="submit" disabled={loading} className="contactsec4-button">
              {loading ? "Submitting..." : "Submit The Request"}
            </Button>
          </div>
        </form>
      </Stack>
      {showSuccess &&
        <div className="hrs-share-backdrop">
          <SuccessModal onClose={() => setShowSuccess(false)} />
        </div>
      }
    </div>
  );
};
